import React from 'react';
import styles from './Badge.module.css';
import BzmIcon from '../icons/BzmIcon';
import clsx from 'clsx';
import { EnumDictionary } from '../../types/Common';

interface BadgeProps {
  variant: BadgeEnum;
  isMinified: boolean;
}

export enum BadgeEnum {
  LIVE,
  DELAYED,
  STATEFUL,
  WEBHOOK,
  HTTP_CALL,
  MEM_OVERRIDE,
}

interface BadgeRepresentation {
  className: string;
  icon: string;
  text: string;
}

const badgeStyles: EnumDictionary<BadgeEnum, BadgeRepresentation> = {
  [BadgeEnum.LIVE]: {
    className: 'badge-primary',
    icon: 'icon-bzm-globe-languagh',
    text: 'Redirect to Live',
  },
  [BadgeEnum.DELAYED]: {
    className: 'badge-warning',
    icon: 'icon-bzm-time',
    text: 'Think Time',
  },
  [BadgeEnum.STATEFUL]: {
    className: styles.purpleBadge,
    icon: 'icon-bzm-stateful',
    text: 'Stateful',
  },
  [BadgeEnum.WEBHOOK]: {
    className: 'badge-attention',
    icon: 'icon-bzm-request',
    text: 'Webhook',
  },
  [BadgeEnum.HTTP_CALL]: {
    className: 'badge-success',
    icon: 'icon-bzm-request',
    text: 'Http Call',
  },
  [BadgeEnum.MEM_OVERRIDE]: {
    className: 'badge-primary',
    icon: 'icon-bzm-cpu',
    text: 'Heap Override',
  },
};

/** Badge representing virtual service functionality. */
const Badge = (props: BadgeProps) => {
  const { variant, isMinified } = props;
  const badge = badgeStyles[variant];
  return (
    <span
      className={clsx('badge', 'badge-pill', styles.badge, badge.className, 'mr-2')}
      style={{ padding: '5px' }}
      title={badge.text}
    >
      <BzmIcon variant={badge.icon} className={'icon-xm ml-0'} /> {!isMinified && badge.text}
    </span>
  );
};

export default Badge;
